export const FETCH_FILTER_ORDER_TRANSACTION_HISTORY = 'FETCH_FILTER_ORDER_TRANSACTION_HISTORY';
export const FETCH_FILTER_ORDER_TRANSACTION_HISTORY_SUCCEED = 'FETCH_FILTER_ORDER_TRANSACTION_HISTORY_SUCCEDD';
export const FETCH_FILTER_ORDER_TRANSACTION_HISTORY_FAILED = 'FETCH_FILTER_ORDER_TRANSACTION_HISTORY_FAILED';

// fetch Pairs Order Transaction History
export const FETCH_USER_ORDER_TRANSACTION_HISTORY = 'FETCH_USER_ORDER_TRANSACTION_HISTORY';
export const FETCH_USER_ORDER_TRANSACTION_HISTORY_SUCCEED = 'FETCH_USER_ORDER_TRANSACTION_HISTORY_SUCCEED';
export const FETCH_USER_ORDER_TRANSACTION_HISTORY_FAILED = 'FETCH_USER_ORDER_TRANSACTION_HISTORY_FAILED';

export const SEARCH_ORDER_TRANSACTION_BY_ID = 'SEARCH_ORDER_TRANSACTION_BY_ID';
export const SEARCH_ORDER_TRANSACTION_BY_ID_SUCCEED = 'SEARCH_ORDER_TRANSACTION_BY_ID_SUCCEED';
export const SEARCH_ORDER_TRANSACTION_BY_ID_FAILED = 'SEARCH_ORDER_TRANSACTION_BY_ID_FAILED';
